import { ensureSubsetOfKeys } from '@daymade/common-lib/types';
import { z } from 'zod';
import {
  zodSelectDrawOrderSchedulePlan,
  zodSelectSubscription,
  zodSelectSubscriptionHistory,
  zodSelectSubscriptionRun,
} from '../generated/zodSchemas.generated';

export const ZSubscriptionSelect = zodSelectSubscription
  .pick({
    id: true,
    status: true,
    playerId: true,
    orderId: true,
    paymentDow: true,
    failedAt: true,
    version: true,
  })
  .extend(
    ensureSubsetOfKeys(zodSelectSubscription.shape, {
      createdAt: z.coerce.date(),
      nextPaymentDate: z.coerce.date(),
      cancelledAt: z.coerce.date().nullable(),
      snoozedUntil: z.coerce.date().nullable(),
    }),
  );

export const ZSubscriptionRunSelect = zodSelectSubscriptionRun
  .pick({
    id: true,
    status: true,
    playerId: true,
    runNumber: true,
    drawOrderId: true,
  })
  .extend({
    createdAt: z.coerce.date(),
  });

export const ZSubscriptionHistorySelect = zodSelectSubscriptionHistory
  .pick({
    id: true,
    createdAt: true,
    action: true,
    additionalInfo: true,
  })
  .extend(
    ensureSubsetOfKeys(zodSelectSubscriptionHistory.shape, {
      createdAt: z.coerce.date(),
    }),
  );

export const ZDrawOrderSchedulePlanSelect = zodSelectDrawOrderSchedulePlan;